export default __webpack_public_path__ + "static/media/login-box.7908f58b.bin";